export default "__VITE_ASSET__DKWcnuMw__"